import { render } from "./Magazzino.vue?vue&type=template&id=79d3fb08&scoped=true&ts=true"
import script from "./Magazzino.vue?vue&type=script&lang=ts"
export * from "./Magazzino.vue?vue&type=script&lang=ts"

import "./Magazzino.vue?vue&type=style&index=0&id=79d3fb08&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1770887991853013682/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d3fb08"]])

export default __exports__